import { useCallback } from 'react';
import { useAddressService } from './useAddressService';

type FetchStreetSuggestionsProps = {
  countryISO?: string;
  postalCode?: string;
  limit: number;
};

export function useFetchStreetSuggestions({
  countryISO,
  postalCode,
  limit,
}: FetchStreetSuggestionsProps): (searchTerm: string) => Promise<string[]> {
  const { addressService } = useAddressService();
  return useCallback(
    async (searchTerm: string) => {
      if (!countryISO || !postalCode) return [];
      const result = await addressService.autoCompleteStreets({
        countryISO,
        limit,
        postalCode,
        key: searchTerm,
      });
      return result.Streets.map((street) => street.Name);
    },
    [addressService, countryISO, limit, postalCode]
  );
}
